import LoadingOverlay from './LoadingOverlay';

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/index.ts